import { createFileRoute } from "@tanstack/react-router";
import TmsCoralSpringsFl from "@/pages/TmsCoralSpringsFl";
export const Route = createFileRoute("/tms-coral-springs-fl")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "TMS therapy in Coral Springs, FL. SAINT TMS, standard TMS, SPRAVATO, ketamine, and therapy for depression at Neuro Wellness TMS Free consultation available.",
        },
        {
          property: "og:title",
          content: "TMS Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "TMS therapy in Coral Springs, FL. SAINT TMS, standard TMS, SPRAVATO, ketamine, and therapy for depression at Neuro Wellness TMS Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/tms-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/tms-coral-springs-fl",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsCoralSpringsFl />;
}
